import styled from "@emotion/styled";
import { Background, Shadow, Typography } from "@ibeckinc/ui-elements";
import Head from "next/head";
import React, { FC, useCallback, useState } from "react";

import { useMobile } from "../../hooks/useMobile";
import { device } from "../../utils";
import { XIcon } from "./XIcon";

const { Text } = Typography;

type Props = {
  className?: string;
  customText: string;
  url: string;
  size?: "small" | "large";
};

export const XPostButton: FC<Props> = ({
  className,
  customText,
  size = "small",
  url,
}) => {
  const { isMobile } = useMobile();

  const [hover, setHover] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setHover(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setHover(false);
  }, []);

  return (
    <>
      <Head>
        <script async src="https://platform.x.com/widgets.js" charSet="utf-8" />
      </Head>
      <Root
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Anchor
          className="twitter-share-button"
          href={`https://x.com/share?${new URLSearchParams({
            url: `${url}/?utm_source=twitter&utm_medium=social&utm_campaign=share`,
            hashtags: "オルタナ,AlternativeCareers,外資,就活",
            text: `${customText}\n`,
            size: "large",
            related: "twitterapi,twitter",
          }).toString()}`}
          target="_blank"
          data-size="large"
        >
          {size === "small" ? (
            <XIcon size={16} color={hover ? "black" : "grey"} />
          ) : (
            <Wrapper>
              <XIcon size={14} color="grey" />
              Post
            </Wrapper>
          )}
        </Anchor>
        {size === "small" && !isMobile() && hover && (
          <Tip>
            <Text bold="bold" lineHeight="small" size="small">
              Post
            </Text>
          </Tip>
        )}
      </Root>
    </>
  );
};

const Root = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 44px;
  width: 44px;
  position: relative;

  @media ${device.mobile} {
    background: ${Background.Base};
    border-radius: 50%;
    box-shadow: ${Shadow.Header};
  }
`;

const Anchor = styled.a`
  text-decoration: none;
`;

const Wrapper = styled.span`
  background-color: #000;
  border-radius: 9999px;
  color: #fff;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 28px;
  width: 72px;
`;

const Tip = styled.div`
  height: 44px;
  width: 80px;
  position: absolute;
  top: 8px;
  left: 40px;
`;
